import { TagsOutlined } from "@ant-design/icons";
import { ProgramsCatalogTable } from "components/Tables/ProgramsCatalogTable/ProgramsCatalogTable";
import { AccountPage } from "components/UI/AccountPage/AccountPage.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { getProgramsCatalogHeaderItems } from "utils/accountHeaderItems.ts";
import { createAccountFileRoute } from "utils/createAccountFileRoute.ts";

export const Route = createAccountFileRoute("/_authenticated/account/_layout/catalog/")({
    component: ProgramsCatalogPage,
    staticData: {
        permissions: [],
        isPublic: true,
        showInSideMenu: true,
        label: "pages.account.programs-catalog.title",
        icon: <TagsOutlined />,
        sort: 2,
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.account.programs-catalog.title"),
    }),
});

function ProgramsCatalogPage() {
    return (
        <AccountPage headerNavigationItems={getProgramsCatalogHeaderItems}>
            <SectionContentWrapper withBackground className={"!p-0"}>
                <ProgramsCatalogTable />
            </SectionContentWrapper>
        </AccountPage>
    );
}
